module.exports = __webpack_public_path__ + "media/images/resources-folder-514fbcb9e7ceb8ccc85848525832b9d8.svg";